import axios, { AxiosResponse, AxiosRequestConfig } from 'axios';
import {
  getTokenFromLocalStorage,
  removeTokenFromLocalStorage
} from './local-storage';

const defaultConfig: AxiosRequestConfig = {
  baseURL: process.env.REACT_APP_BASE_API_URL,
  timeout: 30000,
  headers: {
    'content-type': 'application/json'
  }
};

export const instance = axios.create(defaultConfig);

instance.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    if (config.headers?.Authorization) return config;

    const token = getTokenFromLocalStorage();
    return {
      ...config,
      headers: { ...config.headers, Authorization: `Bearer ${token}` }
    };
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    const path = window.location.pathname;
    if (error?.response?.status === 401 && path !== '/login') {
      removeTokenFromLocalStorage();
      window.location.replace('/');
    }
    return Promise.reject(error);
  }
);

export const http = async <T>({
  url,
  method = 'GET',
  params,
  data,
  ...rest
}: AxiosRequestConfig): Promise<AxiosResponse<T>> =>
  instance({ url, method, params, data, ...rest });
